import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

/**
 * CARFAX integration endpoints. Currently the Car Care data-feed export;
 * QuickVIN and Service History will join when CARFAX issues API credentials.
 */
@Injectable({
  providedIn: 'root'
})
export class CarfaxService {
  private apiUrl = `${environment.apiUrl}/carfax`;

  constructor(private http: HttpClient) {}

  /**
   * Fetch the daily (PROD) feed file for a report day.
   * @param date report day as MMDDYYYY
   */
  downloadProdFeed(date: string): Observable<HttpResponse<string>> {
    return this.http.get(`${this.apiUrl}/feed/download`, {
      params: { type: 'PROD', date },
      observe: 'response',
      responseType: 'text'
    });
  }
}
